import { render, staticRenderFns } from "./LegendarImagem.vue?vue&type=template&id=6655e0b5"
import script from "./LegendarImagem.vue?vue&type=script&lang=js"
export * from "./LegendarImagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports